import React from 'react';
import {Icon} from 'antd';

import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const openSettingsItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел <strong>«Кабинет»</strong>.
            </>
        ),
        area: {
            top: 1,
            left: 34.5,
            width: 5.5,
            height: 6.5
        }
    },
    {
        id: 'legal-entities',
        number: 2,
        content: (
            <>
                Откройте вкладку
                <strong> «Юридические лица»</strong>.
            </>
        ),
        area: {
            top: 39.2,
            left: 3.18,
            width: 21.79,
            height: 6.66
        }
    },
    {
        id: 'vat-button',
        number: 3,
        content: (
            <>
                Нажмите кнопку <strong>«НДС» </strong> у нужного
                юридического лица.
            </>
        ),
        area: {
            top: 63.27,
            left: 84.79,
            width: 3.41,
            height: 6.66
        }
    }
];


const noVatItems = [
    {
        id: 'no-vat',
        number: 1,
        content: (
            <>
                Выберите вариант <strong>«Нет»</strong>.
            </>
        ),
        area: {
            top: 64.44,
            left: 12.71,
            width: 5.33,
            height: 5.78
        }
    },
    {
        id: 'save-no-vat',
        number: 2,
        content: (
            <>
                Нажмите кнопку <strong>«Сохранить»</strong>.
            </>
        ),
        area: {
            top: 84.48,
            left: 41.88,
            width: 16.35,
            height: 6.91
        }
    }
];


const vatRateItems = [
    {
        id: 'with-vat',
        number: 1,
        content: (
            <>
                Выберите вариант <strong>«Да»</strong>.
            </>
        ),
        area: {
            top: 56.92,
            left: 7.38,
            width: 4.54,
            height: 4.9
        }
    },
    {
        id: 'vat-rate',
        number: 2,
        content: (
            <>
                Откройте список и выберите применяемую ставку:
                <strong> 5%, 7% или 22%</strong>.
            </>
        ),
        area: {
            top: 71.83,
            left: 6.92,
            width: 86.27,
            height: 23.69
        }
    }
];


const taxDocumentItems = [
    {
        id: 'tax-document',
        number: 1,
        content: (
            <>
                Загрузите документ, подтверждающий изменение
                системы налогообложения.
            </>
        ),
        area: {
            top: 68.44,
            left: 7.04,
            width: 42.23,
            height: 17.33
        }
    },
    {
        id: 'save-with-vat',
        number: 2,
        content: (
            <>
                Нажмите кнопку <strong>«Сохранить»</strong>.
            </>
        ),
        area: {
            top: 90.76,
            left: 41.88,
            width: 16.35,
            height: 4.26
        }
    }
];


export default function VatInstruction() {
    return (
        <InstructionLayout title="Указание НДС">
            <p className="instruction-intro">
                Перевозчик должен указать, работает ли выбранное
                юридическое лицо с НДС. При работе с НДС также
                необходимо выбрать ставку и при необходимости
                прикрепить подтверждающий документ.
            </p>

            <div className="service-highlight">
                <span className="service-highlight__icon">
                    <Icon type="warning"/>
                </span>

                <div>
                    <strong className="service-highlight__title">
                        Выбор обязателен
                    </strong>

                    <p className="service-highlight__text">
                        Окно выбора способа налогообложения нельзя закрыть,
                        пока не будет указано, работает юридическое лицо
                        с НДС или без НДС.
                    </p>
                </div>
            </div>

            <InstructionStep
                number="1"
                title="Откройте настройки НДС"
            >
                <div className="instruction-copy">
                    <p>
                        Окно выбора способа налогообложения может
                        открыться автоматически после входа
                        в личный кабинет.
                    </p>

                    <p>
                        При необходимости настройки можно открыть
                        вручную в карточке юридического лица.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vat/01-open-vat-settings.png"
                    alt="Кнопка НДС в списке юридических лиц"
                    items={openSettingsItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Укажите работу без НДС"
            >
                <div className="instruction-copy">
                    <p>
                        Если юридическое лицо продолжает работать
                        без НДС, выберите соответствующий вариант
                        и сохраните изменения.
                    </p>

                    <p>
                        В этом случае прикреплять дополнительные
                        документы не требуется.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vat/02-no-vat.png"
                    alt="Выбор работы без НДС"
                    items={noVatItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Выберите ставку НДС"
            >
                <div className="instruction-copy">
                    <p>
                        Если юридическое лицо работает с НДС,
                        укажите применяемую ставку.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vat/03-select-vat-rate.png"
                    alt="Выбор ставки НДС"
                    items={vatRateItems}
                />
            </InstructionStep>

            <InstructionStep
                number="4"
                title="Прикрепите подтверждающий документ"
            >
                <div className="instruction-copy">
                    <p>
                        Если система налогообложения изменилась,
                        загрузите справку или информационное письмо,
                        подтверждающее изменение.
                    </p>

                    <p>
                        После загрузки документа сохраните выбранные
                        настройки.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/vat/04-upload-tax-document.png"
                    alt="Загрузка документа, подтверждающего систему налогообложения"
                    items={taxDocumentItems}
                />

                <div className="service-section__media">
                    <div className="service-note">
                        <Icon
                            className="service-note__icon"
                            type="info-circle"
                        />

                        <p className="service-note__text">
                            Для юридических лиц и ИП, применяющих
                            НДС 5%, 7% или 22%, в дальнейшем могут
                            потребоваться документы, подтверждающие
                            сдачу отчётности. Состав документов
                            и сроки предоставления сообщаются отдельно.
                        </p>
                    </div>
                </div>
            </InstructionStep>
        </InstructionLayout>
    );
}